export default function IconPause() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M27 6V26C27 26.5304 26.7893 27.0391 26.4142 27.4142C26.0391 27.7893 25.5304 28 25 28H20.5C19.9696 28 19.4609 27.7893 19.0858 27.4142C18.7107 27.0391 18.5 26.5304 18.5 26V6C18.5 5.46957 18.7107 4.96086 19.0858 4.58579C19.4609 4.21071 19.9696 4 20.5 4H25C25.5304 4 26.0391 4.21071 26.4142 4.58579C26.7893 4.96086 27 5.46957 27 6ZM11.5 4H7C6.46957 4 5.96086 4.21071 5.58579 4.58579C5.21071 4.96086 5 5.46957 5 6V26C5 26.5304 5.21071 27.0391 5.58579 27.4142C5.96086 27.7893 6.46957 28 7 28H11.5C12.0304 28 12.5391 27.7893 12.9142 27.4142C13.2893 27.0391 13.5 26.5304 13.5 26V6C13.5 5.46957 13.2893 4.96086 12.9142 4.58579C12.5391 4.21071 12.0304 4 11.5 4Z"
        // fill="#1C1C1C"
        fill="rgba(155, 155, 155, 1)"
      />
    </svg>
  );
}
